import { testi, user } from "../assets/index";

export const data = [
  {
    name: "Holy Family Church Menai",
    img: testi,
    area: "Menai",
    review:
      " ❝ Daniel and Sean did an amazing job with the Church. Cleaning the concrete ground outside the perimeter of the Church, it was black with the weather. They brought it back to looking new again. Also cleaned the exterior of the building, again was covered in dirt and black mold. All gone!! ❞ ",
  },
  {
    name: "Michelle Pickett, Sutherland",
    area: "Sutherland",
    img: testi,
    review:
      "❝ Sean & Daniel did an amazing job pressure cleaning and sealing my mum’s stencilling - it looks like new and she can't believe how good it looks. Thank you both for such a professional job you did. She would recommend them to anyone, they are so helpful and went above and beyond of what was quoted. ❞",
  },
  {
    name: "La Renaissance, Oyster Bay",
    area: "Caringbah",
    img: testi,
    review:
      "❝ We had our house cleaned this week and they did a fantastic job - the driveway is at least 4 shades lighter and the house exterior has never looked cleaner. All traces of mould, dirt, cobwebs are gone and no mess left behind. Thank you very much!! ❞",
  },
  {
    name: "Freddy Lopez, Lidcombe",
    img: testi,
    area: "Alfords Point",
    review:
      "❝ Sean's service exceeded my expectations! I reached out to him to clean the area around my pool and the walls of my house, and I'm extremely impressed with the results. Not only did he do an amazing job, but he also managed to make it look as good as new! Sean's attention to detail and professionalism truly shines through his work. I highly recommend his services to anyone.❞",
  },
  {
    name: "Paul Elarde, Loftus",
    img: testi,
    area: "Loftus",
    review:
      "❝ Sean and Daniel did a wonderful job on our drive and path ways which were covered in mould and dirt over many years.  Now transformed like new!  Rare to find honest, hardworking, skilled team like these guys.  ❞",
  },
  {
    name: "Donna Halpin, Grays Point",
    img: testi,
    area: "Grays Point",
    review:
      "❝ We have engaged Total Exterior Cleaning 3 times in the past few months - cleaning windows, gutters, roof and also some pressure cleaning on our never ending retaining walls. Each time they arrived on time and completed the job making all surfaces look brand new. ❞",
  },
  {
    name: "Theresa Chisari, Bangor",
    img: testi,
    area: "Bangor",
    review:
      "❝ Thank you to the team at TOTAL EXTERIOR CLEANING for their incredible job today, they went above and beyond with our cleaning job. Our house is shining and I can look out our windows! The team are professional and knowledgeable and I can’t wait to have them back! ❞",
  },
  {
    name: "Mariylnn Thomas, Helensburgh",
    img: testi,
    area: "Bangor",
    review:
      "❝ Sean and Daniel did a great job cleaning our gutters today.  It wasn't an easy task but they handled it efficiently and professionally.  Very friendly and good communicators.  I would be happy recommend them. ❞",
  },
  {
    name: "Declan, Wollongong",
    img: testi,
    area: "Wollongong",
    review:
      "❝ Sean and Daniel did an amazing job cleaning the windows and tiles of my apartment balcony. They cleaned up after themselves and had great communication. ❞",
  },
  {
    name: "Joshua Swan, Menai",
    img: testi,
    area: "Menai",
    review:
      "❝ Friendly, reliable and quick service. I would highly recommend. ❞",
  },

  {
    name: "Mike Issa, Illawong",
    area: "Illawong",
    img: testi,
    review:
      "❝ Thank you for the great job. Windows and driveway came up beautifully...Highly recommend and will use again. ❞",
  },
  {
    name: "Paul Para, Caringbah",
    area: "Caringbah",
    img: testi,
    review:
      "❝ Had my driveway cleaned, they did a great job! It looked brand new again. Very friendly also, would highly recommend. ❞",
  },
];
